import { render, staticRenderFns } from "./Certificates.vue?vue&type=template&id=19ca359c"
import script from "./Certificates.vue?vue&type=script&lang=ts"
export * from "./Certificates.vue?vue&type=script&lang=ts"
import style0 from "./Certificates.vue?vue&type=style&index=0&id=19ca359c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports